'use strict';

angular.module('theme').component('shopCartNotice', {
	templateUrl: 'component/shop-cart-notice.html',
	controller: function($rootScope, $window, $location, $timeout, $cookies, ShopService) {
		var self = this;

		self.$onInit = function() {
			self.showNotice = false;
			self.currentUrl = $location.absUrl();

			self.checkCartExpireDate();
		};

		// Show 10 minute shop cart notice 
		this.checkCartExpireDate = function() {
			var cart = $cookies.getObject('shop-cart');

			if (cart) {
				var notice = moment().add(10, 'minutes');
				if (!self.currentUrl.includes('/checkout/') && cart.notice !== true && cart.cartArticles.length > 0 && notice.isAfter(cart.expires)) {
					cart.notice = true;

					$timeout(function() {
						self.showNotice = true;

						$cookies.putObject('shop-cart', cart, {
							path: '/'
						});
					});
				}

				// Clear cart if expired
				var currentTime = moment();
				if (currentTime.isAfter(cart.expires)) {
					self.showNotice = false;
					ShopService.clearCart(cart);
				}
			}

			$timeout(function() {
				self.checkCartExpireDate();
			}, 10000);
		};

		this.toCheckout = function() {
			self.showNotice = true;
			
			// Update cart cookie
			var cart = $cookies.getObject('shop-cart');

			if (cart) {
				cart.notice = true;
				$cookies.putObject('shop-cart', cart, {
					path: '/'
				});
			}

			$window.location.href = '/shop/checkout/';
		};

	}
});
